<script>
	export let conditions;
	let interventions = [
		{ value: "", label: "None" },
		{
			value: "default-modal",
			label: "Default (popup/modal) (experimental)",
		},
		{
			value: "accprompt-infeed",
			label: "Accuracy prompt (in-feed) (coming soon!)",
		},
		{
			value: "accprompt-modal",
			label: "Accuracy prompt (popup/modal) (coming soon!)",
		},
	];
	let interventionParams = [];
	let inputDefaultValue = "";
	let interventionPercDefaultValue = 50;
	let interventionDisabled = [];
	let showPerc = 0;

	const getStorage = (conditions) => {
		let params = JSON.parse(localStorage.getItem("createStudyParams"));
		if (params) {
			if (params.interventionParams) {
				interventionParams = params["interventionParams"];
			}
		} else {
			params = {};
		}
		// if no intervention parameters in localStorage yet, create and populate it with default value
		if (!interventionParams) {
			interventionParams = [];
			for (let i = 0; i < conditions; i++) {
				interventionParams.push({
					"intervention-type": inputDefaultValue,
					"intervention-perc": interventionPercDefaultValue,
				});
			}
		} else {
			// if intervention parameters in localStorage, check if it has the right number of conditions
			if (interventionParams.length < conditions) {
				// if not, add the missing conditions
				for (let i = interventionParams.length; i < conditions; i++) {
					interventionParams.push({
						"intervention-type": inputDefaultValue,
						"intervention-perc": interventionPercDefaultValue,
					});
				}
			}
		}
		params["interventionParams"] = interventionParams;
		localStorage.setItem("createStudyParams", JSON.stringify(params));
	};
	getStorage();
	$: getStorage(conditions);

	const updateStorage = (parameters) => {
		let params = JSON.parse(localStorage.getItem("createStudyParams"));
		params["interventionParams"] = parameters;
		localStorage.setItem("createStudyParams", JSON.stringify(params));
	};
	$: updateStorage(interventionParams);

	$: if (interventionParams.length > 0) {
		for (let i = 0; i < interventionParams.length; i++) {
			if (interventionParams[i]["intervention-type"] === "") {
				interventionDisabled[i] = true;
				interventionParams[i]["intervention-perc"] =
					interventionPercDefaultValue;
			} else {
				interventionDisabled[i] = false;
			}
		}
	}
	// determine whether to show the intervention percentage slider
	$: {
		showPerc = 0;
		if (interventionParams.length > 0) {
			interventionDisabled.slice(0, conditions).forEach((disabled) => {
				if (!disabled) {
					showPerc++;
				}
			});
		}
	}

	const formatForAPI = (conditions, parameters, parameterName) => {
		// console.log(parameters);
		let paramsSelected = JSON.parse(
			localStorage.getItem("createStudyParamsSelected"),
		);

		let formatted = [];
		for (let i = 0; i < conditions; i++) {
			let interventionType = parameters[i][parameterName + "-type"];
			formatted.push({
				condition: i + 1,
				param: parameterName + "-type",
				value: interventionType,
			});
			// if intervention-type is "", then set intervention-perc to ""
			let interventionPerc = parameters[i][parameterName + "-perc"];
			if (interventionType === "") {
				interventionPerc = "";
			}
			formatted.push({
				condition: i + 1,
				param: parameterName + "-perc",
				value: interventionPerc,
			});
		}
		if (paramsSelected) {
			paramsSelected[parameterName] = formatted;
		} else {
			paramsSelected = {};
			paramsSelected[parameterName] = formatted;
		}
		localStorage.setItem(
			"createStudyParamsSelected",
			JSON.stringify(paramsSelected),
		);
	};
	$: formatForAPI(conditions, interventionParams, "intervention");
</script>

<hr />
<h3>Intervention type</h3>

{#each { length: conditions } as _, ii}
	<p><strong>Condition {ii + 1}</strong></p>
	<div>
		<label for={"condition-" + (ii + 1) + ";intervention"} />
		<select
			name={"condition-" + (ii + 1) + ";intervention"}
			bind:value={interventionParams[ii]["intervention-type"]}
		>
			{#each interventions as intervention}
				<option value={intervention.value}>{intervention.label}</option>
			{/each}
		</select>
	</div>
{/each}

{#if showPerc}
	<h3>Percent through study intervention will appear</h3>
	{#each { length: conditions } as _, ii}
		<p>Condition {ii + 1}</p>
		<div class="slider">
			<input
				name={"condition-" + (ii + 1) + ";intervention-perc"}
				disabled={interventionDisabled[ii]}
				type="range"
				min="1"
				max="100"
				bind:value={interventionParams[ii]["intervention-perc"]}
				step="1"
				oninput={"perccondition" + (ii + 1) + ".innerText = this.value"}
			/>
			<span id={"perccondition" + (ii + 1)} />
		</div>
	{/each}
{/if}

<style>
	label {
		margin-bottom: 13px;
		font-size: 1.1em;
	}
</style>
